import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelbezeichnungsaufbauServiceConfig = {
  name: "Artikelbezeichnungsaufbau",
  annotations: []
} as ServiceConfig;